<div class="data-section">
  <div class="data-section-heading">{{ 'surgical_qa_panel.diagnosis_before_surgeries' | translate }}</div>
  <div class="data-section-content">
    @for (diagnosis of diagnoses; track diagnosis) {
    <stx-historic-diagnose-detail-row [diagnosis]="diagnosis"></stx-historic-diagnose-detail-row>
    }
  </div>
</div>
